import * as React from 'react';
import { useDataPoints, DataPointModal } from '@web-config-app/data-points';
import { useEntityDetailsProps } from '@web-config-app/entity-form';

export const JsonLogicInputTopBarDataPointButton = () => {
  const { rootSchema, currentAuthoringEnvironment, entityType } =
    useEntityDetailsProps();

  /**
   * Fetch all available data points at the entity level for this specific entity type and environment.
   *
   * The data points can be copy and pasted into their JSON Logic input when building custom rules.
   */
  const {
    dataPoints,
    isError: dataPointModalError,
    isLoading: dataPointModalLoading,
  } = useDataPoints({
    schema: {
      'x-entity-data-point': {
        dataPointSources: ['dml', 'config'],
      },
    },
    rootSchema,
    currentAuthoringEnvironment,
    entityType,
  });

  const shouldRender = dataPoints?.length > 0;

  if (!shouldRender) {
    return null;
  }

  return (
    <DataPointModal
      dataPoints={dataPoints}
      isError={dataPointModalError}
      isLoading={dataPointModalLoading}
      mode="copy"
    />
  );
};
